import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入表单校验插件
import "@/utils/vee-validate-schema";
//钉钉步进体
import "@/assets/text/text.css";

Vue.config.productionTip = false

Vue.use(ElementUI)

import websocketApi from './utils/websocket';
Vue.prototype.$websocketApi = websocketApi;//websocket挂在原型上

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
